import React from "react";
import DOMPurify from "dompurify";

/** Render a string that *may* contain a small subset of inline HTML
 *  (<strong>, <em>, <a>, <br>) coming from the CMS. Anything else is
 *  stripped by DOMPurify. */
const ALLOWED_TAGS = ["strong", "b", "em", "i", "a", "br", "span"];
const ALLOWED_ATTR = ["href", "target", "rel", "class"];

function looksLikeHtml(value) {
  return typeof value === "string" && /<\/?(strong|b|em|i|a|br|span)\b/i.test(value);
}

export default function RichText({ value, as: Tag = "span", className, testId }) {
  if (!value) return null;
  if (!looksLikeHtml(value)) {
    return <Tag className={className} data-testid={testId}>{value}</Tag>;
  }
  const clean = DOMPurify.sanitize(value, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ["target", "rel"],
  });
  return (
    <Tag
      className={className}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
